/* src/app/components/edit-assessment/edit-assessment.component.scss */
.material-icons-down-icon {
  top: 7px;
  position: relative;
  left: 4px;
  color: white;
}
.caret-icons-up-icon {
  top: -2px;
  position: relative;
  left: -5px;
  color: white;
}
.caret-drop-icons-up-icon {
  top: -2px;
  position: relative;
  left: -5px;
  color: white;
}
.font-color {
  color: white;
  height: 42px;
}
.border-bottom {
  border-bottom: 1px solid #ddd;
}
.assesment-position {
  position: relative;
  top: 7px;
}
.row1 {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}
.points-position {
  position: relative;
  top: 7px;
  width: 70px !important;
  height: 32px;
}
.page-link {
  background-color: #ddd;
  color: black;
  border: 5px solid white;
}
.page-link:hover {
  background-color: black;
  color: white;
  border: 5px solid white;
}
.edit-selectall {
  position: relative;
  padding-bottom: 36px;
  padding-top: 3px;
}
.point-cnt {
  padding-left: 0;
  padding-top: 3px;
}
.material-icons-pagination {
  top: 16px;
  position: relative;
}
.button-position {
  position: relative;
  bottom: 2px;
}
.btn-secondary {
  color: black;
  background-color: #ddd;
  border: none;
}
.textstyle {
  background-color: #9e9c9c;
  font-weight: normal;
  border-radius: 22px;
  width: auto;
  height: auto;
  padding: 5px 20px 5px 20px;
  font-size: 13px;
  color: white;
}
.textstyle a {
  color: #fff;
  text-decoration: underline;
}
.search-icon-style {
  background-color: #ddd;
  font-weight: bold;
  border-radius: 4px;
  height: 30px;
  padding: 6px 12px 5px 18px;
  font-size: 15px;
  color: black;
  margin-left: 10px;
}
.cursor-style {
  cursor: pointer;
}
.edit-list {
  overflow-y: scroll;
  position: relative;
  overflow-x: hidden;
}
.page-title {
  font-size: 20px;
}
#source-picker #select-bank {
  background-color: #fafafa;
  border-right: 1px solid #bdbdbd;
}
.css-flex-table {
  display: flex;
  width: 80%;
}
.css-flex-table-header,
.css-flex-table-body {
  display: flex;
  flex: 0 0 100%;
}
.css-flex-table,
.css-flex-table-body {
  flex-wrap: wrap;
}
.css-flex-table-header div {
  padding: 6px;
  text-align: center;
  font-weight: bold;
  background-color: rgb(191, 191, 191);
}
.css-flex-table-header div,
.css-flex-table-body div {
  flex: 0 1 100px;
  padding: 0 6px;
  border: 1px solid rgb(255, 255, 255);
  box-sizing: border-box;
}
.css-flex-table-header div:nth-of-type(4n),
.css-flex-table-body div:nth-of-type(4n) {
  flex: 0 1 calc(100% - 308px);
}
.centerText {
  text-align: center;
  font-weight: bold;
  padding-top: 7%;
  font-size: 18px;
}
.center {
  margin-left: 38%;
  padding-top: 5%;
}
.zero-state {
  position: relative;
  background-color: #e6e5e5;
}
.align-middle {
  position: absolute;
  left: 46%;
  top: 44%;
}
::ng-deep .ahe-ui-checkbox > input[type=checkbox] + span::before {
  background-color: white;
}
.footer-step2 {
  position: fixed;
  bottom: 0;
}
a.disabled {
  pointer-events: none;
  cursor: default;
}
.handles {
  cursor: move;
}
.question-title label:hover {
  cursor: pointer;
  color: #007c91;
  text-decoration: underline;
}
.pointWidth {
  padding: 0;
}
.buttonsPanel {
  border-top: none;
  padding-left: 0px;
}
.qpickerIcons.algorithmicBig {
  background-position: -36px !important;
  display: inline-block;
  height: 28px;
  width: 24px;
}
.addQuestionEditAlign {
  min-width: 190px;
  padding: 0 !important;
  bottom: 3px;
  position: relative;
}
#questionTypeContainer {
  display: inline-block;
  position: relative;
}
.editQuestionsHandle {
  float: right;
  margin-top: 4px;
  margin-right: 17px;
}
.child-cont-1 {
  float: left;
  width: 15%;
  padding: 5px;
}
.child-cont-2 {
  float: left;
  width: 55%;
  padding: 13px 10px 0px 13px;
  color: black;
}
.section-break-cont {
  border: 1px #f0f3f4 solid;
  background-color: #f0f3f4 !important;
  padding-bottom: 15px;
  border-left: 1px #f0f3f4 solid;
  border-right: 1px #f0f3f4 solid;
  border-bottom: 1px #bdbdbd solid;
}
.section-part-tbl {
  height: auto;
  margin-left: 9px;
  border-collapse: separate;
  border-radius: 6px;
  border: solid 1px #bdbdbd;
  -moz-border-radius: 6px;
  border-spacing: 4px;
  background-color: white;
}
.section-part-tbl tr {
  border: none;
}
.section-part-tbl td {
  font-weight: bold;
}
.qtype-margin {
  left: 53px !important;
  margin-top: 1.5rem;
}
.points-margin {
  left: 100px;
  margin-top: 1rem;
}
.kebab-dot-margin {
  left: 69px;
  padding-top: 12px;
}
.modal-overlay {
  background-color: rgba(0, 0, 0, 0.2);
}
.modal-container-new {
  position: relative;
  width: 100%;
  background: transparent;
  height: 100%;
}
.modal-header-new {
  background-color: #174d5c;
  color: #fff;
  height: 45px;
  padding: 12px 18px 12px 30px;
}
.modal-body-new {
  position: relative;
  flex: 1 1 auto;
  padding: 30px;
}
.modal-body-copy {
  position: relative;
  flex: 1 1 auto;
  padding: 30px 0 0 30px;
}
.modal-dialog-copy {
  position: fixed;
  top: 50%;
  width: 30%;
  left: 33%;
  z-index: 1010;
  margin: 0px auto;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.modal-footer-new {
  display: flex;
  align-items: center;
  padding: 1rem;
  border-top: 1px solid #e9ecef;
  background-color: #f0f3f4;
}
.modal-footer-new button {
  width: 130px;
}
.bottom-border {
  border-bottom: 1px solid #bdbdbd;
}
.top-border {
  border-top: 1px solid #bdbdbd;
}
.border-top-left-radius {
  border-top-left-radius: 6px;
}
.border-top-right-radius {
  border-top-right-radius: 6px;
}
.border-bottom-left-radius {
  border-bottom-left-radius: 6px;
}
.border-bottom-right-radius {
  border-bottom-right-radius: 6px;
}
.part-background {
  background: #fff;
}
.part-border-left {
  border-left: 1px solid #bdbdbd;
}
.part-border-right {
  border-right: 1px solid #bdbdbd;
  right: 17px;
}
.previewButtonStyle {
  position: relative;
  left: 82px;
}
.footer-pad {
  padding: 0;
  position: fixed;
  bottom: 0;
  z-index: 5;
}
.empty-test-message {
  font-family: "proxima_novaregular_bold";
  font-weight: 500;
  color: #222222;
}
.zero-state-container {
  margin-bottom: 72px;
  min-height: 270px;
}
/*# sourceMappingURL=edit-assessment.component.css.map */
